import { render, staticRenderFns } from "./AktivitasValidasiItem.vue?vue&type=template&id=5b51f212&scoped=true&lang=html&"
import script from "./AktivitasValidasiItem.vue?vue&type=script&lang=js&"
export * from "./AktivitasValidasiItem.vue?vue&type=script&lang=js&"
import style0 from "./AktivitasValidasiItem.vue?vue&type=style&index=0&id=5b51f212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b51f212",
  null
  
)

export default component.exports